@use '~/theme/theme' as *;

.radiogroup {
  display: flex;
  flex-direction: column;
  gap: spacing(1);
}

.errorMessage {
  color: color(lobster-900);
}
